import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useTextPresets, type TextField } from "@/features/standaardteksten/useTextPresets";

/** A field's own quick-select row: buttons that insert, not a `Select` (see ADR-0028). */
export function PresetChips({
  field,
  onSelect,
}: {
  field: TextField;
  onSelect: (text: string) => void;
}) {
  const { t } = useTranslation("wedstrijden");
  const { data: presets } = useTextPresets();
  const options = presets?.filter((preset) => preset.field === field) ?? [];

  if (options.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-sm text-muted-foreground">{t("boekje.standaardtekstenLabel")}</span>
      {options.map((preset) => (
        <Button
          key={preset.id}
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onSelect(preset.text)}
        >
          {preset.text}
        </Button>
      ))}
    </div>
  );
}
